import React from "react";

export default function RestaurantAd({ ad }) {
  return (
    <a
      className="explore-restaurant-ad"
      target="_blank"
      href={ad.client_href.web}
      style={{ backgroundColor: ad.bg_color }}
    >
      <div className="explore-restaurant-ad--pic">
        <img className="ad-cover" src={ad.image_url} alt="" />
      </div>
      <div
        className="explore-restaurant-ad--text"
        style={{ color: ad.color || "#252525" }}
      >
        {ad.description}
      </div>
      <div
        className="explore-restaurant-ad--btn"
        style={{ backgroundColor: ad.button.bg_color, color: ad.button.color }}
      >
        {ad.button.text}
      </div>
    </a>
  );
}
